function SvgBuildings({ color = "#60A6FF", width = 20, height = 20, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.8346 18.3327H4.16797C2.5013 18.3327 1.66797 17.4993 1.66797 15.8327V9.16602C1.66797 7.49935 2.5013 6.66602 4.16797 6.66602H8.33464V15.8327C8.33464 17.4993 9.16797 18.3327 10.8346 18.3327Z"
        stroke={color || color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.42629 3.33398C8.35962 3.58398 8.33464 3.85898 8.33464 4.16732V6.66732H4.16797V5.00065C4.16797 4.08398 4.91797 3.33398 5.83464 3.33398H8.42629Z"
        stroke={color || color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.668 6.66602V10.8327"
        stroke={color || color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 6.66602V10.8327"
        stroke={color || color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.168 14.166H12.5013C12.043 14.166 11.668 14.541 11.668 14.9993V18.3327H15.0013V14.9993C15.0013 14.541 14.6263 14.166 14.168 14.166Z"
        stroke={color || color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 10.834V14.1673"
        stroke={color || color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33203 15.8327V4.16602C8.33203 2.49935 9.16536 1.66602 10.832 1.66602H15.832C17.4987 1.66602 18.332 2.49935 18.332 4.16602V15.8327C18.332 17.4993 17.4987 18.3327 15.832 18.3327H10.832C9.16536 18.3327 8.33203 17.4993 8.33203 15.8327Z"
        stroke={color || color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgBuildings;
